import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";


export const usePageHeaderTools = () => {

    const tools = [<ReloadRecordsButton key='reload'/>];
    return {tools};
}
